import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HeartFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M11.6143 21.1436C11.8516 21.2858 12.1484 21.2858 12.3857 21.1436C12.6661 20.9637 13.5137 20.4196 13.9912 20.0869C14.9449 19.4224 16.2205 18.4732 17.499 17.335C18.7743 16.1996 20.0728 14.8587 21.0576 13.4102C22.0377 11.9685 22.75 10.3565 22.75 8.69434C22.7499 5.45202 20.3484 2.75 17 2.75C15.4082 2.75 13.8662 3.26268 12 4.96484C10.1338 3.26268 8.59184 2.75 7 2.75C3.65156 2.75 1.25005 5.45202 1.25 8.69434C1.25 10.3565 1.96225 11.9685 2.94238 13.4102C3.92725 14.8587 5.22567 16.1996 6.50098 17.335C7.77947 18.4732 9.05506 19.4224 10.0088 20.0869C10.4863 20.4196 11.3339 20.9637 11.6143 21.1436Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HeartFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HeartFilledIcon;
